<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { formsApi, type Form } from '@/services/api/forms';
import ProjectsSubNav from './ProjectsSubNav.vue';

const route = useRoute();
const form = ref<Form | null>(null);

function ids(): { projectId: string; formId: string } {
  const p = route.params.id;
  const f = route.params.form ?? route.params.form_id;
  return {
    projectId: Array.isArray(p) ? (p[0] ?? '') : p ?? '',
    formId: Array.isArray(f) ? (f[0] ?? '') : f ?? '',
  };
}

async function reload(): Promise<void> {
  const { projectId, formId } = ids();
  form.value = await formsApi.get(projectId, formId);
}

onMounted(reload);
</script>

<template>
  <div>
    <ProjectsSubNav :project-id="ids().projectId" />
    <section v-if="form" class="resource">
      <h1>{{ form.name }}</h1>
      <p>{{ form.description }}</p>
      <h2 class="resource__subtitle">Sections</h2>
      <ul class="resource__list">
        <li v-for="s in form.sections ?? []" :key="(s as any).id">
          <span>{{ (s as any).display_name ?? (s as any).name ?? 'Section' }}</span>
        </li>
      </ul>
    </section>
    <p v-else class="resource">Loading…</p>
  </div>
</template>

<style scoped src="@/assets/styles/resource-list.scss"></style>
<style scoped>
.resource__subtitle {
  margin-top: 1.5rem;
}
</style>
